export default class Optimizer {

  static ErrorCodes = class {
    static POINT_ROUTING_ERROR = "POINT_ROUTING_ERROR";
    static CANNOT_TAKE_OPERATIONS_WITH_TAG = "CANNOT_TAKE_OPERATIONS_WITH_TAG";
    static CANNOT_TAKE_OPERATIONS_WITHOUT_TAG = "CANNOT_TAKE_OPERATIONS_WITHOUT_TAG";
  }

  static processSolverErrors(errors, optimizationBody, spotsTemporal, t) {
    let detailHtml = null;
    if (errors && errors.length > 0) {

      let processPointRoutingError = this.processPointRoutingError(errors, optimizationBody, spotsTemporal, t);
      if (processPointRoutingError) {
        detailHtml = (detailHtml ?? '') + processPointRoutingError;
      }

      let processCannotTakeOperations = this.processCannotTakeOperations(errors, optimizationBody, t);
      if (processCannotTakeOperations) {
        detailHtml = (detailHtml ?? '') + processCannotTakeOperations;
      }

    }

    return detailHtml;
  }

  static processPointRoutingError(errors, optimizationBody, spotsTemporal, t){
    let detailHtml = null;

    // Para error al intentar rutear
    let pointRoutingError = errors.filter((e) => e.code && e.code === this.ErrorCodes.POINT_ROUTING_ERROR);
    if (pointRoutingError && pointRoutingError.length > 0) {
      let listIndexes = [];
      let listNames = [];
      pointRoutingError.forEach((p) => {
        if (p.path.includes('spots')) {
          const index = p.path.replace('spots[', '').replace(']', '');
          const address = optimizationBody.spots[index].extraInfo.address;
          const rowIndex = this.findRowIndexForAddress(address, listIndexes, spotsTemporal);

          // si encuentras indice, es que es una carga masiva
          if (rowIndex) {
            listIndexes.push(rowIndex);
          } else {
            // si no, es carga manual
            const spotId = optimizationBody.spots[index].id;
            optimizationBody.operations
              .filter((o) => o.spot === spotId)
              .forEach((op) => {
                listNames.push(op.name);
              });
          }
        }
      });

      if (listIndexes.length > 0) {
        detailHtml = "<div class='m-2'>";
        detailHtml += '<label>' + t('planification.solver.pointRoutingErrorExcel') + '</label>';
        detailHtml += '<ul><li>' + t('planification.solver.row') + listIndexes.sort() + '</li></ul>';
        detailHtml += '</div>';
      }

      if (listNames.length > 0) {
        detailHtml = "<div class='m-2'>";
        detailHtml += '<label>' + t('planification.solver.pointRoutingError') + '</label><ul>';
        listNames.forEach((name) => {
          detailHtml += '<li>' + name + '</li>';
        });
        detailHtml += '</ul></div>';
      }
    }

    return detailHtml;
  }

  static processCannotTakeOperations(errors, optimizationBody, t) {
    let detailHtml = null;
    let cannotTakeOperations = errors.filter((e) => e.code && (
      e.code === this.ErrorCodes.CANNOT_TAKE_OPERATIONS_WITH_TAG || 
      e.code === this.ErrorCodes.CANNOT_TAKE_OPERATIONS_WITHOUT_TAG)
    );
    if (cannotTakeOperations && cannotTakeOperations.length > 0) {
      let listResourcesTags = [];
      let listResourcesNoTags = [];
      cannotTakeOperations.forEach((p) => {
        if (p.path.includes('resources')) {
          const index = p.path.replace('resources[', '').replace(']', '');
          let res = optimizationBody.resources[index];

          if (p.code === this.ErrorCodes.CANNOT_TAKE_OPERATIONS_WITH_TAG) {
            listResourcesTags.push(res.name);
          } else if (p.code === this.ErrorCodes.CANNOT_TAKE_OPERATIONS_WITHOUT_TAG) {
            listResourcesNoTags.push(res.name);
          }
        }
      });

      if (listResourcesTags.length > 0 || listResourcesNoTags.length > 0) {
        detailHtml = (detailHtml ?? '') + "<div class='mx-2 mt-1'>";
        detailHtml += '<label>' + t('planification.solver.unusableResources') + '</label>';
        detailHtml += '</div>';
      }

      if (listResourcesTags.length > 0) {
        detailHtml += "<div class='mt-1 ml-3'>";
        detailHtml += '<label>' + t('planification.solver.cannotAssignByTag') + '</label>';
        detailHtml += '<ul><li>' + listResourcesTags.sort() + '</li></ul>';
        detailHtml += '</div>';
      }

      if (listResourcesNoTags.length > 0) {
        detailHtml += "<div class='mt-1 ml-3'>";
        detailHtml += '<label>' + t('planification.solver.cannotAssignByNoTags') + '</label>';
        detailHtml += '<ul><li>' + listResourcesNoTags.sort() + '</li></ul>';
        detailHtml += '</div>';
      }
    }
    
    return detailHtml;
  }

  static findRowIndexForAddress(address, listIndexes, spotsTemporal) {
    for (let row = 0; row < spotsTemporal.length; row++) {
      const spot = spotsTemporal[row];

      let fullAddress = spot.address;        
      if(spot.addressComplement) fullAddress += ',' + spot.addressComplement;
      if(spot.neighborhood) fullAddress += ',' + spot.neighborhood;
      fullAddress += ',' + spot.city;
      fullAddress += ',' + spot.state;
      fullAddress += ',' + spot.country;

      if (!listIndexes.includes(row + 2) && address.includes(fullAddress)) return row + 2;
    }
    return null;
  }

}